import { defineComponent as _defineComponent } from 'vue'
import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { GoingViralSpotlightModuleFragment } from '@/features/onboarded-home/types';

import BasicTitleCardGraphql from '@/components/list/title-card/BasicTitleCardGraphql.vue';
import SpotlightCardCornerTag from '@/features/onboarded-home/components/modules/spotlights/SpotlightCardCornerTag.vue';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';

import { formatRuntime } from '@/helpers/title-helper';
import { useI18n } from '@/helpers/composables/useI18n';

import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GoingViralSpotlightModuleCard',
  props: {
    title: null,
    tagText: null,
    cardIndex: null,
    additionalContexts: { default: () => [] }
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props as { title: GoingViralSpotlightModuleFragment['titles'][number], tagText: string, cardIndex: number, additionalContexts: SnowplowContext[] };





const { t } = useI18n();

const progressBarValue = ref(0);
const root = ref<HTMLElement | null>(null);

const moveProgress = [
	{ opacity: 0.8, transform: 'translateX(-100%)', transformOrigin: 'left' },
	{ opacity: 1, transform: `translateX(0%)` },
];

function onCardVisibility(isVisible: boolean) {
	const viralScore = props.title?.content?.scoring?.viral;
	if (isVisible && viralScore) {
		progressBarValue.value = Math.round(viralScore * 100);

		// TODO: make RTL
		const moveTiming: KeyframeAnimationOptions = {
			duration: 2000,
			delay: props.cardIndex <= 1 ? 1500 : 500,
			iterations: 1,
			fill: 'forwards',
			easing: 'ease-in',
		};

		root.value?.querySelector('.jw-progress-bar__value')?.animate(moveProgress, moveTiming);
	}
}

const restructuredTitle = computed(() => {
	if (props.title.__typename === 'Season') {
		return {
			...props.title,
			id: props.title.show.id,
			objectId: props.title.show.objectId,
			objectType: props.title.show.objectType,
			content: {
				...props.title.content,
				title: props.title.show.content.title,
			},
			watchlistEntryV2: props.title.show.watchlistEntryV2,
			likelistEntry: props.title.show.likelistEntry,
			dislikelistEntry: props.title.show.dislikelistEntry,
		};
	}

	return props.title;
});

const titleName = computed(() =>
	props.title.__typename === 'Season' ? props.title.show.content.title : props.title.content.title
);

const stats = computed(() => {
	const stats = `${props.title.content.originalReleaseYear}`;

	if (props.title.content.runtime == null) return stats;

	const { translationKey, hours, minutes } = formatRuntime(props.title.content.runtime);

	if (isNaN(hours)) return stats;

	return `${stats} &#183; ${t(translationKey, { hours, minutes })}`;
});

return { __sfc: true,props, t, progressBarValue, root, moveProgress, onCardVisibility, restructuredTitle, titleName, stats, BasicTitleCardGraphql, SpotlightCardCornerTag, TitleDetailLink }
}

})